/**
 * Date/time formatting for field notices.
 *
 * Always in the time zone of the action (concept 9.2), never the browser's
 * and never the server's local zone. The zone is passed in explicitly for the
 * same reason the backend injects a clock: otherwise the deadline logic is only
 * testable in a live run.
 */
const LOCALE = 'de-DE';
/**
 * The last moment before an exclusive end, for printing a deadline.
 *
 * The daily draw ends at local midnight, exclusively (`participation_ends_at`, the backend's
 * `end_of_day`), and printed as it is that reads "bis 00:00 Uhr". One millisecond earlier is
 * the last moment that still counts: "23:59 Uhr", which is what the participant is promised
 * (concept 9.6.1). An inclusive end like 23:59:59 prints the same.
 */
export function lastMomentBefore(isoTimestamp) {
    return new Date(Date.parse(isoTimestamp) - 1).toISOString();
}
export function formatTimeOfDay(isoTimestamp, timeZone) {
    return new Intl.DateTimeFormat(LOCALE, {
        timeZone,
        hour: '2-digit',
        minute: '2-digit',
    }).format(new Date(isoTimestamp));
}
export function formatDate(isoTimestamp, timeZone) {
    return new Intl.DateTimeFormat(LOCALE, {
        timeZone,
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    }).format(new Date(isoTimestamp));
}
export function formatDateTime(isoTimestamp, timeZone) {
    return `${formatDate(isoTimestamp, timeZone)}, ${formatTimeOfDay(isoTimestamp, timeZone)} Uhr`;
}
//# sourceMappingURL=format.js.map